import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAppDispatch } from '@application/store/useStore';
import VnGrid from '@ui/components/VnGrid';
import OrdersTable from './OrdersTable';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { setWorkOrderNumberAtOrder } from '@application/features/orders/orderSlice';
const OrdersTab = ({ formData, errors, onFieldChange, onToggelButtonChange, onCalendarChange, isOrderTabBold }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    useEffect(() => { }, [dispatch]);
    useEffect(() => { }, [formData]);
    function onOrderRowClick(rowId) { }
    function onCreateOrders() {
        if (formData.workOrderNumber && formData.id) {
            const workOrderData = {
                label: formData.workOrderNumber,
                value: formData.id
            };
            dispatch(setWorkOrderNumberAtOrder(workOrderData));
            navigate('/admin/OrderTabs');
        }
    }
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'vn-workorder-Container', children: _jsx(VnGrid, { children: _jsx(OrdersTable, { onRowClick: onOrderRowClick, isOrderTabBold: isOrderTabBold }) }) }) }));
};
export default OrdersTab;
